import React, { useState } from 'react'
import { Drawer, Button, Form, Upload } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import { UploadOutlined } from '@ant-design/icons'
import openNotification from 'utils/Notification'
import { sum } from 'lodash'
import FilterBackButton from 'assets/images/new-images/filter-back-button.svg'

const TicketReopenModel = ({ visible, onClose, closeTicket }) => {
  const [form] = Form.useForm()
  const [fileList, setFileList] = useState([])

  // ✅ handle submit via validateFields
  const handleReopen = async () => {
    try {
      const values = await form.validateFields()
      const payload = {
        status: 'REOPEN',
        description: values.description,
        fileUrl: values?.fileUrl?.length ? values?.fileUrl : null,
      }
      form
        .validateFields()
        .then(async (values) => {
          let mb = 0
          if (payload?.fileUrl) {
            const totalSize = sum(payload?.fileUrl?.map((item) => item?.size))
            mb = totalSize / 1024 / 1024
          }
          if (mb >= 3) {
            openNotification('error', `You can't upload more than 3 MB file`)
          } else {
            await closeTicket(payload)
            form.resetFields() // ✅ reset form fields
            setFileList([])
            onClose()
          }
        })
        .catch((info) => console.log('Validate Failed:', info))
    } catch (error) {
      console.log('Form validation failed:', error)
    }
  }

  // ✅ keep file handling consistent
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e
    }

    const newFileList = [...(e?.fileList || [])]
    if (newFileList.length > 6) {
      // openNotification('error', 'Cannot upload more than 6 files');
      return newFileList.slice(0, 6)
    }
    return newFileList
  }

  const customProps = {
    multiple: true,
    onRemove: (file) => {
      const currentFileList = form.getFieldValue('fileUrl') || []
      const updatedFileList = currentFileList.filter(
        (item) => item.uid !== file.uid
      )
      form.setFieldsValue({ fileUrl: updatedFileList })
    },
    beforeUpload: (file, fileList) => {
      if (fileList.length > 6) {
        return Upload.LIST_IGNORE
      }
      setFileList(file)
      return false // prevent auto-upload
    },
    fileList,
  }

  return (
    <Drawer
      title={null}
      headerStyle={{ display: 'none' }}
      closable={false}
      placement='right'
      visible={visible}
      width={472}
      onClose={onClose} // ✅ keep close separate from submit
    >
      <div
        style={{
          margin: '32px 0 50px 0',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div onClick={() => onClose()}>
          <img src={FilterBackButton} alt='FilterBackButton' />
        </div>
        <div
          style={{
            fontSize: '24px',
            fontWeight: '700',
            lineHeight: '28px',
            color: '#000000',
            marginLeft: '16px',
          }}
        >
          Re-open Ticket
        </div>
      </div>

      <div style={{ padding: '0 16px' }}>
        <Form
          form={form}
          layout='vertical'
          className='ticket-reopen-form-model-span'
        >
          <Form.Item
            label='Description'
            name='description'
            rules={[
              { required: true, message: 'Please provide a Description' },
            ]}
          >
            <TextArea placeholder='Write Here' rows={4} />
          </Form.Item>

          <Form.Item
            name='fileUrl'
            label='File'
            valuePropName='fileList'
            getValueFromEvent={normFile}
            rules={[
              {
                validator: (_, value) =>
                  value?.length > 6
                    ? Promise.reject(
                        new Error('Cannot upload more than 6 files')
                      )
                    : Promise.resolve(),
              },
            ]}
          >
            <Upload name='attachment' listType='text' {...customProps}>
              <Button>
                <UploadOutlined /> Select file
              </Button>
            </Upload>
          </Form.Item>
        </Form>
      </div>

      {/* Footer buttons */}
      <div
        style={{
          position: 'absolute',
          bottom: '0',
          left: '0',
          width: '100%',
          backgroundColor: '#fff',
          display: 'flex',
          gap: '20px',
          height: '56px',
          margin: '20px 0px',
          padding: '0 16px',
        }}
      >
        <Button
          style={{
            width: '100%',
            borderRadius: '8px',
            padding: '8px',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          type='primary'
          style={{
            width: '100%',
            borderRadius: '8px',
            padding: '8px',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={handleReopen}
        >
          Re-open
        </Button>
      </div>
    </Drawer>
  )
}

export default TicketReopenModel
